import ViewAsYAML from './ViewAsYAML.view';

export default ViewAsYAML;
